import type { TenantPluginRegister } from '@yeshuman/sdk'

import { CanvasEditorPage } from './canvases/canvas-editor-page'
import { CanvasesPage } from './canvases/canvases-page'
import { PublicSlidePage } from './slides/public-slide-page'
import { SlideEditorPage } from './slides/slide-editor-page'
import { SlidesPage } from './slides/slides-page'
import { workingSessionAdmin, workingSessionDoorEnabled } from './working-session/send-session-actions'
import { WorkingSessionPage } from './working-session/working-session-page'

export const register: TenantPluginRegister = (app) => {
  app.register({
    guestMarketingShellBackground: false,
  })
  app.routes.add({ path: '/slides', element: SlidesPage })
  app.routes.add({ path: '/slides/:id', element: SlideEditorPage })
  app.routes.add({ path: '/canvases', element: CanvasesPage })
  app.routes.add({ path: '/canvases/:id', element: CanvasEditorPage })
  app.publicShare.route({ path: '/s/:slug', element: PublicSlidePage })
  app.publicShare.route({ path: '/session/:token', element: WorkingSessionPage })
  if (workingSessionDoorEnabled()) {
    app.accessRequests.admin(workingSessionAdmin)
  }
  for (const focus of ['candidate', 'employer', 'platform', 'developer']) {
    app.nav.add(focus, [
      { path: '/slides', icon: 'LayoutGrid', requiresFeature: 'slides', label: 'Slides' },
      { path: '/canvases', icon: 'ClipboardList', requiresFeature: 'canvases', label: 'Canvases' },
    ])
  }
}

export const requiresProduct = '>=2.6,<3'
